import { Button, Typography } from "@mui/material";
import Flex from "../../../Flex";

/**
 * A custom input component that allows selecting one or more
 * days of the week.
 *
 * @param selectedDays An array of weekdays currently selected
 * @param onChange A callback called when the selected days change
 * @param error Validation errors
 */

const weekdayLabels = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
const workingDays = [1, 2, 3, 4, 5];

const WeekdayChooser: React.FC<{
  label: string;
  selectedDays: number[];
  onChange: (value: number[]) => void;
  error: React.ReactNode;
}> = ({ label, selectedDays, onChange, error }) => {
  return (
    <>
      <Typography fontWeight={500} my={"5px"}>
        {label} :
      </Typography>
      <Typography variant="caption" color="error">
        {error}
      </Typography>
      <Flex flexDirection={"column"} gap={1}>
        <Flex gap={1}>
          {weekdayLabels.map((label, weekday) => {
            const isSelected = selectedDays?.indexOf(weekday) !== -1;
            const isWeekend = weekday === 0 || weekday === 6;

            return (
              <Button
                sx={{
                  padding: "2px",
                  margin: "2px",
                  ...(isWeekend && !isSelected
                    ? {
                        borderColor: "error.main",
                        color: "error.main",
                        "&:hover": {
                          borderColor: "error.main",
                        },
                      }
                    : {}),
                }}
                key={weekday}
                variant={isSelected ? "contained" : "outlined"}
                onClick={() => {
                  const inx = selectedDays.indexOf(weekday);
                  const updated =
                    inx > -1
                      ? selectedDays.filter((n) => n != weekday)
                      : [...selectedDays, weekday];

                  onChange(updated);
                }}
              >
                {label}
              </Button>
            );
          })}
        </Flex>
        <Flex gap={1} mb={3} mt={1} justifyContent={"start"}>
          <Button
            variant="outlined"
            onClick={() => onChange(workingDays)}
            sx={{
              margin: "2px",
            }}
          >
            Select Working Days
          </Button>

          <Button
            onClick={() => onChange([])}
            color="error"
            variant="outlined"
            sx={{
              margin: "2px",
            }}
          >
            Clear
          </Button>
        </Flex>
      </Flex>
    </>
  );
};

export default WeekdayChooser;
